import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import {
  createPageAnnotationSlice,
  PageAnnotationSlice,
} from "~/features/pageAnnotations/store/pageAnnotation.slice";
import {
  createSearchHighlightSlice,
  SearchHighlightSlice,
} from "./searchHighlight.slice";
import { createSidebarSlice, SidebarSlice } from "./sideBar.slice";

export type SkyViewStore = SidebarSlice &
  SearchHighlightSlice &
  PageAnnotationSlice;

export const useSkyViewStore = create<SkyViewStore>()(
  persist(
    immer((...a) => ({
      ...createSidebarSlice(...a),
      ...createSearchHighlightSlice(...a),
      ...createPageAnnotationSlice(...a),
    })),
    {
      name: "sky-view-storage",
      partialize: (state) => ({
        isExpanded: state.isExpanded,
        isDocListCollapsed: state.isDocListCollapsed,
      }),
    }
  )
);
